export default {
  form: {
    versions: {
      label: 'Version',
      placeholder: 'Version auswählen',
    },
    font_family: {
      label: 'Schriftfamilie',
    },
    background_color: {
      label: 'Hintergrundfarbe',
    },
    promo_frame_primary_color: {
      label: 'Aktionsrahmenfarbe',
    },
    promo_frame_discount_label_color: {
      label: 'Rabattlabelfarbe im Aktionsrahmen',
    },
    vip_members_cta_color: {
      label: 'VIP-Mitglieder CTA-Farbe',
    },
    url_cta_color: {
      label: 'URL CTA-Farbe',
    },
    url_color: {
      label: 'URL-Farbe',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL auswählen',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'QR-Code Rahmenfarbe',
    },
    qr_code_background_color: {
      label: 'QR-Code Hintergrundfarbe',
    },
    footer_background_color: {
      label: 'Hintergrundfarbe der Fußzeile',
    },
    logo_zoom: {
      label: 'Logogröße',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Sticker konnte nicht geladen werden',
  },
};
